import { EmailAuthProvider, GoogleAuthProvider, User } from 'firebase/auth';

export type EmailVerificationUser = Pick<User, 'emailVerified' | 'providerData'>;

export const isGoogleAuthUser = (user: EmailVerificationUser): boolean =>
  user.providerData.some((provider) => provider.providerId === GoogleAuthProvider.PROVIDER_ID);

export const isEmailPasswordAuthUser = (user: EmailVerificationUser): boolean =>
  user.providerData.some((provider) => provider.providerId === EmailAuthProvider.PROVIDER_ID);

export const shouldRequireEmailVerification = (
  user: EmailVerificationUser | null | undefined,
  requireEmailVerification: boolean,
): boolean => {
  if (
    !user ||
    user.emailVerified ||
    isGoogleAuthUser(user) ||
    !isEmailPasswordAuthUser(user) ||
    !requireEmailVerification
  ) {
    return false;
  }

  return true;
};
